export const Message = {
  show: (Boolean, false),
  message: (String, ""),
};

export const User = {
  countryCode: (Number, 0),
  distributor_id: (String, ""),
  name: (String, ""),
  status_key: (Number, 0),
};

export const VivaCart = {
  items: (Array, []),
  totalPV: (Number, 0),
  totalPrice: (Number, 0),
  totalTax: (Number, 0),
  totalAfterTax: (Number, 0),
};

export const VivaCartItem = {
  image: (String, ""),
  name: (String, ""),
  quantity: (String, ""),
  price: (String, ""),
};

export const VivaCustomer = {
  Fullname: (String, ""),
  TransactionId: (String, ""),
  Mobile: (String, ""),
  AddressLine1: (String, ""),
  AddressLine2: (String, ""),
  Landmark: (String, ""),
  City: (String, ""),
  State: (String, ""),
  Pincode: (String, ""),
  OrderDate: (String, ""),
  PaymentMode: (String, ""),
  Cart: (VivaCart, {}),
  DistributorId: (String, ""),
};

export const Product = {
  id: (Number, 0),
  countrykey: (Number, 0),
  currencykey: (Number, 0),
  producttypekey: (Number, 0),
  productcode: (Number, 0),
  productname: (String, ""),
  shortdescription: (String, ""),
  fulldescription: (String, ""),
  packing: (String, ""),
  retailprice: (Number, 0),
  basicprice: (Number, 0),
  distributorprice: (Number, 0),
  pointvalue: (Number, 0),
  productimagename: (String, ""),
  shoppingcartindex: (Number, 0),
  hsn: (Number, 0),
  ProductCategory: (Number, 0),
  freeprod_tax_ref: (Number, 0),
  localretailprice: (Number, 0),
  localbasicprice: (Number, 0),
  localdistributorprice: (Number, 0),
  createdby: (Number, 0),
  createdon: (String, ""),
  modifiedby: (Number, 0),
  modifiedon: (String, ""),
  statuskey: (Number, 0),
  skuprdid: (Number, 0),
  assessable_value: (String, ""),
  prd_type: (Number, 0),
  mrp: (String, ""),
  assessable_value1: (String, ""),

  //isSelected: (Boolean, false),
  productImage: (String, ""),
  quantity: (Number, 0),
  totalPrice: (Number, 0),
};

export const ProductImages = [
  {
    productImageName: "9",
    productImage: "ipulse.jpg",
  },
  {
    productImageName: "433",
    productImage: "icare.jpg",
  },
  {
    productImageName: "10",
    productImage: "icoffee - creamer f.jpg",
  },
  {
    productImageName: "47",
    productImage: "icoffee - black f.jpg",
  },
  {
    productImageName: "49",
    productImage: "islim 2.2.jpg",
  },
  {
    productImageName: "111",
    productImage: "iglow.jpg",
  },
];
